/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_Contacts_NewsletterPreferenceCollectionResult } from '../models/Gsoa_Contacts_NewsletterPreferenceCollectionResult';
import type { Gsoa_Contacts_RequestNewsletterParams } from '../models/Gsoa_Contacts_RequestNewsletterParams';
import type { Gsoa_Contacts_UpdatePreferencesParams } from '../models/Gsoa_Contacts_UpdatePreferencesParams';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaContactsService {
    /**
     * Sends a request for a double opt-in newsletter subscription.
     * @returns void
     * @throws ApiError
     */
    public static requestNewsletter({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: Gsoa_Contacts_RequestNewsletterParams,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/contacts/newsletter/new',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Retrieves all set newsletter preferences for an already subscribed contact.
     * @returns Gsoa_Contacts_NewsletterPreferenceCollectionResult Preferences has been retrieved.
     * @throws ApiError
     */
    public static getNewsletterPreferences({
        apiVersion = 1,
        email,
        hashCode,
    }: {
        apiVersion?: number,
        /**
         * Customer e-mail.
         */
        email?: string,
        /**
         * SHA-1 hash code.
         */
        hashCode?: string,
    }): CancelablePromise<Gsoa_Contacts_NewsletterPreferenceCollectionResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/contacts/newsletter/preferences',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'email': email,
                'hashCode': hashCode,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Updates the preference settings for an already subscribed contact.
     * @returns any Request has been sent.
     * @throws ApiError
     */
    public static updateNewsletterPreferences({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: Gsoa_Contacts_UpdatePreferencesParams,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/contacts/newsletter/preferences',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
